import React from 'react';

class WorkDetail extends React.Component {
  workListStorageKey = 'pyovspyo_work_items';

  state = {
    title: '',
    content: '',
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const routedItem = this.props.location.state && this.props.location.state.workItem
      ? this.props.location.state.workItem
      : null;

    if (routedItem && String(routedItem.id) === String(id)) {
      this.setState({
        title: routedItem.title || '',
        content: routedItem.content || ''
      });
      return;
    }

    const storedItems = sessionStorage.getItem(this.workListStorageKey);
    const workItems = storedItems ? JSON.parse(storedItems) : [];
    const matchedItem = workItems.find((item) => String(item.id) === String(id));

    if (matchedItem) {
      this.setState({
        title: matchedItem.title || '',
        content: matchedItem.content || ''
      });
    }
  }

  render() {
    return (
      <>
        <div className="text-center">
          <h1 className="project-title">{this.state.title}</h1>
          <div className="work-detail" dangerouslySetInnerHTML={{ __html: this.state.content }} />
        </div>
      </>
    )
  }
}

export default WorkDetail;
